import {
  branchBasedFeedbackDataFilter,
  getActiveBranchIds1,
} from "../multipleBranch/getActiveBranchId";
import {
  dateExactMatcherForReport,
  getAllDatesBetweenTwoDates,
} from "./linechartReporting";

export function ratingBarGraphReport(data1, dates) {
  console.log(data1);
  // input data here is raw feedback data..
  if (dates == null) return null;
  if (data1 == null || data1.length == 0) return null;
  const branch = getActiveBranchIds1();
  // console.log(data1);
  if (branch.length > 1) return null;
  const data = branchBasedFeedbackDataFilter(data1, branch[0]);

  // console.log(data);
  if (data?.length == 0 || data == null) {
    return;
  }

  //Phase 1 Extracting relevant info from Feedback Data.
  // first we prepare data in date and star frequency form,
  let rawData = {
    dates: [],
    oneStar: [],
    fiveStar: [],
  };

  // Now we start filling the rawData object.
  rawData.dates = getAllDatesBetweenTwoDates(dates).outputDates;
  rawData.labels = getAllDatesBetweenTwoDates(dates).outputLabels;
  rawData.dates.forEach((d, index) => {
    let oneStr = 0;
    let fiveStr = 0;

    data.forEach((item) => {
      if (dateExactMatcherForReport(d, item.createdAt)) {
        if (item.rating == 5) fiveStr++;
        if (item.rating == 1) oneStr++;
      }
      rawData.oneStar[index] = oneStr;
      rawData.fiveStar[index] = fiveStr;
    });
  });

  // Phase 2now we fill the raw data object inside the resultData in format which is accepted by bar chart
  let resultData = {
    labels: [],
    datasets: [
      {
        label: "1 Star",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "5 Star",
        data: [],
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
  };

  // we reverse() so that dates start from Left to right ie latest being on Right side.
  resultData.labels = [...rawData.labels].reverse();
  resultData.datasets[0].data = [...rawData.oneStar].reverse();
  resultData.datasets[1].data = [...rawData.fiveStar].reverse();

  return resultData;
}
